import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuidePillar,
  GuidePillarGrid,
  GuideContrast,
} from "../GuideBlocks.js";

const BringingItTogetherSection = ({ heading, accentIndex = 1, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="bringing-it-together"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Emotional awareness is not about becoming emotionless. It is about choosing responses from
      examined thinking instead of impulse.
    </GuideLead>
    <p className="guide-panel__p">
      When you recognize your emotions, understand your patterns, identify your triggers, regulate
      your responses, and build resilience, you become better equipped to handle both success and
      adversity.
    </p>
    <GuideContrast
      items={[
        {
          title: "Awareness creates understanding.",
          text: "Emotions are not obstacles to clear thinking — when understood, they become valuable sources of information.",
        },
        {
          title: "Understanding creates choice.",
          text: "Choice creates updated beliefs. Updated beliefs lead to clearer decisions and stronger response discipline.",
        },
      ]}
    />
    <GuideSectionLabel>Pause and examine</GuideSectionLabel>
    <p className="guide-panel__p">
      Whenever you notice a strong emotion, pause and work through these steps before you respond:
    </p>
    <GuidePillarGrid columns={3}>
      <GuidePillar title="Name the feeling">What am I feeling right now?</GuidePillar>
      <GuidePillar title="Check the interpretation">What meaning am I assigning to this?</GuidePillar>
      <GuidePillar title="Choose the response">
        What response aligns with evidence instead of impulse?
      </GuidePillar>
    </GuidePillarGrid>
    <GuideCallout variant="amber">
      Small moments of awareness build lasting response discipline. Every strong emotion is an
      opportunity—name it, check the interpretation, then respond with intention.
    </GuideCallout>
  </GuidePanel>
);

export default BringingItTogetherSection;
